import { Pipe, PipeTransform } from '@angular/core';
import { maintenanceOutcomes } from '@flyfreely-portal-ui/flyfreely';
import { setupStatusFormatter } from '../helpers';

@Pipe({ name: 'formatMaintenanceOutcome' })
export class FormatMaintenanceOutcomePipe implements PipeTransform {
    transform: (value: any, ...args: any[]) => any;

    constructor() {
        this.transform = setupStatusFormatter(maintenanceOutcomes);
    }
}
